import React from 'react';
import './Header.css';
import { Link } from 'react-router-dom';

const Header = () => {

    const openSocials1 = () => {
        window.open('https://t.me/MovinMonkey_AI', '_blank');
    }

    const openSocials2 = () => {
        window.open('https://x.com/movinmonkeysol', '_blank');
    }

    return (
        <div className = 'Header'>
            <div className = 'Header-Content'>
                <Link to = "/" className = 'Header-Content-Project'>movinmonkey ai</Link>
                <div className = 'Header-Content-Buttons'>
                    <button onClick={openSocials2} to = "/" className = 'Header-Content-Buttons-Button'>Twitter</button>
                    <button onClick={openSocials1} to = "/" className = 'Header-Content-Buttons-Button'>Telegram</button>
                </div>
            </div>
        </div>
    );
};

export default Header;